import React from 'react';
import { useSelector } from 'react-redux';
import { IModal } from 'types';
import { MODAL } from 'config/constants';
import { ReqestModal, AutoUploadModal } from 'pages/Profile/modals';
import {
  VirtualServiceModal,
  FloorplanModal,
  AdditionalPicturesModal,
  PictureSwapModal,
  ShareMediaModal,
  AiServicesModal,
  GeneratedPhotosModal,
  OrderServiceOfferModal,
  ChangeFloorTypeModal,
} from 'pages/Delivery/modals';
import { HvLoginModal } from 'components';
import {
  AddNewFavoriteListingModal,
  RemoveFavoriteListingModal,
} from 'pages/PersonalPortal/components/EditPage/modals';
import { SchedulerModal } from 'pages/ProdScheduler/components';
import {
  PortalSectionTemplateModal,
  EditTestimonialsModal,
} from 'pages/PersonalPortal/components/EditPage/modals/CustomSectionModals';
import {
  ShootingEditModal,
  ShootingCancelModal,
  DraftShootingDeleteModal,
  DraftShootingSaveModal,
  RecommendationModal,
  SuccessModal,
} from '../Shootings/modals';

function Modals() {
  const { modals } = useSelector((state: any) => {
    return state.app;
  });

  const renderModal = (modal: IModal) => {
    const { type, data } = modal || {};
    switch (type) {
      case MODAL.SHOOTING_EDIT:
        return (
          <ShootingEditModal
            key='createShooting'
            shootingId={data?.shootingId}
            isUpdateDate={data?.isUpdateDate || false}
            bookAnotherShoot={data?.bookAnotherShoot || false}
          />
        );
      case MODAL.SHOOTING_CANCEL:
        return <ShootingCancelModal key='cancelShooting' shootingId={data.shootingId} />;
      case MODAL.DRAFT_SHOOTING_DELETE:
        return <DraftShootingDeleteModal key='deleteDraftShooting' shootingId={data.shootingId} />;
      case MODAL.DRAFT_SHOOTING_SAVE:
        return <DraftShootingSaveModal key='saveDraftShooting' shooting={data.shooting} />;
      case MODAL.TRANSER_REQUEST:
        return <ReqestModal />;
      case MODAL.AUTO_UPLOAD:
        return (
          <AutoUploadModal
            key='autoUpload'
            automatic_saisie={data.automatic_saisie}
            onSave={data.onSave}
            updateAutomaticSaisie={data.updateAutomaticSaisie}
          />
        );
      case MODAL.LOGIN:
        return <HvLoginModal key='loginModal' />;
      case MODAL.VIRTUAL_STAGING:
        return <VirtualServiceModal key='virtualServiceModal' />;
      case MODAL.FLOORPLAN:
        return <FloorplanModal key='floorplanModal' />;
      case MODAL.ADDITIONAL_PICTURES:
        return <AdditionalPicturesModal data={data} key='additionalPictures' />;
      case MODAL.PICTURE_SWAP:
        return <PictureSwapModal key='pictureSwapModal' />;
      case MODAL.RECOMMENDATION:
        return <RecommendationModal key='serviceOffersRecommendation' />;
      case MODAL.ADD_NEW_FAVORITE_LISTING:
        return <AddNewFavoriteListingModal key='addNewFavoriteListingModal' />;
      case MODAL.REMOVE_FAVORITE_LISTING:
        return (
          <RemoveFavoriteListingModal
            key='removeFavoriteListingModal'
            listing_id={data.listing_id}
          />
        );
      case MODAL.SHARE:
        return <ShareMediaModal key='shareMediaModal' listing={data.listing} />;
      case MODAL.AI_SERVICES:
        return (
          <AiServicesModal
            key='aiServicesModal'
            selectedService={data.selectedService}
            opened_from_ai_section={data.opened_from_ai_section}
          />
        );
      case MODAL.GENERATED_PHOTOS:
        return (
          <GeneratedPhotosModal
            key='generatedPhotosModal'
            order_id={data.order_id}
            listing_id={data.listing_id}
          />
        );
      case MODAL.SCHEDULER_MODAL:
        return <SchedulerModal key='schedulerModal' />;
      case MODAL.SECTION_TEMPLATE:
        return <PortalSectionTemplateModal key='sectionTemplateModal' />;
      case MODAL.EDIT_TESTIMONIALS:
        return <EditTestimonialsModal key='editTestimonialModal' />;
      case MODAL.ORDER_SERVICE_OFFER:
        return (
          <OrderServiceOfferModal
            key='orderServiceOfferModal'
            modalKey={data.key}
            exampleImage={data.exampleImage}
            headerImage={data.headerImage}
            modalTitle={data.modalTitle}
            serviceOffer={data.serviceOffer}
            shooting_id={data.shooting_id}
          />
        );
      case MODAL.CHANGE_FLOOR_TYPE:
        return <ChangeFloorTypeModal room={data.room} floor_type={data.floor_type} />;
      case MODAL.SUCCESS:
        return (
          <SuccessModal
            key='successModal'
            image={data.image}
            modalTitle={data.modalTitle}
            buttonText={data.buttonText}
            buttonAction={data.buttonAction}
            description={data.description}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {modals.map((m: IModal) => {
        return renderModal(m);
      })}
    </>
  );
}

export default Modals;
